export const TITLE_TABLE = [
  {
    label: 'library.savePortfolio.PORTFOLIO',
    key: 'portfolioName',
  },
  {
    label: 'library.savePortfolio.NUMBER_OF_COMPANIES',
    key: 'numberOfCompany',
  },
  {
    label: 'library.savePortfolio.ALERT_PROFILE',
    key: 'alertProfileId',
  },
  {
    label: 'library.savePortfolio.DATE_CREATED',
    key: 'createDate',
  },
  {
    label: 'library.savePortfolio.DATE_MODIFIED',
    key: 'updateDate',
  },
  {
    label: ' ',
    key: 'col6',
  },
]

export const ALERT_PROFILE = [
  { label: 'Standard Alert', value: 1 },
  { label: 'Severe Alert', value: 1 },
  { label: 'Not set', value: 0 },
  { label: 'Profile name 1', value: 1 },
]

export const SELECT_PORTFOLIO = [
  {
    label: 'library.savePortfolio.savePortfolio',
    value: 'portfolio',
    isI18n: true,
  },
  {
    label: 'library.savePortfolio.COMPANY',
    value: 'company',
    isI18n: true,
  },
]

export const PORTFOLIO_VALUES = {
  COMPANY: 'company',
  PORTFOLIO: 'portfolio',
}

export const TYPE_GET_PORTFOLIO = {
  WITH_COMPANY: 'WITH_COMPANY',
  WITH_SEARCH: 'WITH_SEARCH',
  NORMAL: 'NORMAL',
}

export const STATUS_CHECK_BOX = {
  ALL_PORTFOLIO: 'ALL_PORTFOLIO',
  ALL_PORTFOLIO_OUT: 'ALL_PORTFOLIO_OUT',
  NORMAL: 'NORMAL',
}
